exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.transfer-confirm__subject-field[data-v-4fec8910] {\n  padding-top: 0;\n}\n.transfer-confirm__inner[data-v-4fec8910] {\n  margin-top: 12px;\n}\n.transfer-confirm__fees .detail-row[data-v-4fec8910] {\n  white-space: nowrap;\n}\n.fees__title[data-v-4fec8910],\n.recipient__title[data-v-4fec8910] {\n  margin-top: 12px;\n  color: #578AD6;\n}\n@media only screen and (max-width: medium) {\n.fees__title[data-v-4fec8910],\n    .recipient__title[data-v-4fec8910] {\n      text-align: left;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4fec8910","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/transfers/make/Transfers.Confirm.vue
// module id = WRTZ
// module chunks = 1